// extracted by mini-css-extract-plugin
export default {"options":"CustomStationsListOptions_options__1qxDN"};